import { Breakpoint } from 'antd/lib/_util/responsiveObserve';
import styled, { createGlobalStyle } from 'styled-components';
import { Check } from '@styled-icons/bootstrap/Check';
import { CheckCircleFill } from '@styled-icons/bootstrap/CheckCircleFill';
import { Cross } from '@styled-icons/entypo/Cross';
import { MinusOutline } from '@styled-icons/evaicons-outline/MinusOutline';
// eslint-disable-next-line import/order
import { PlusOutline } from '@styled-icons/evaicons-outline/PlusOutline';

export const FallbackImage =
  'data:image/png;base64,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';

export declare type Breakpoints = Breakpoint;

export const size = {
  xs: 480,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1600,
};

export const menubarBreakPoint = 1420;

export const device = {
  xs: `(max-width: ${size.xs}px)`,
  sm: `(max-width: ${size.sm}px)`,
  md: `(max-width: ${size.md}px)`,
  lg: `(max-width: ${size.lg}px)`,
  xl: `(max-width: ${size.xl}px)`,
  xxl: `(max-width: ${size.xxl}px)`,
};
export const PrimaryColor = '#003159';
export const SecondaryColor = '#3cac40';
export const MenteeColor = '#6f6baa';
export const LightGrayColor = '#f9f9f9';
export const Colors = {
  black: '#000000',
  white: '#ffffff',
  grey0: '#F9F9F9',
  grey1: '#E4E4E4',
  grey2: '#AEAEAE',
  grey3: '#666666',
  grey4: '#747474',
  grey5: '#C4C4C4',
  danger: '#de4949',
  blue: '#3366ff',
  background: '#F0F8F6',
};

export const PlusOutlineIcon = styled(PlusOutline)`
  width: 1rem;
`;
export const MinusOutlineIcon = styled(MinusOutline)`
  width: 1rem;
`;

type TBackgroundType = {
  type?: string;
  position: string;
  right?: string;
  top?: string;
};

export const StyledIconBackground = styled.div<TBackgroundType>`
  position:${(props) => props.position};
  right:${(props) => props.right && props.right};
  top:${(props) => props.top && props.top};
  margin-left: 20px;
  width: 17px;
  height: 17px;
  border-radius: 50%;
  /* background-color: ${SecondaryColor}; */
  ${(props) => props.type === 'green' && `background-color: ${SecondaryColor};`}
  ${(props) => props.type === 'danger' && `background-color: ${Colors.danger}`}

`;

export const StyledCheckIcon = styled(Check)`
  width: 18px;
  fill: ${Colors.white};
  position: absolute;
  right: 0.1px;
`;

export const StyledCrossIcon = styled(Cross)`
  width: 17px;
  fill: ${Colors.white};
  position: absolute;
  /* left: 0.001px; */
`;

export const StyledSectionCover = styled.div`
  pointer-events: none;
  position: absolute;
  z-index: 10;
  background-color: ${Colors.grey1};
  opacity: 0.5;
  width: 200%;
  height: 200%;
`;

const GlobalStyles = createGlobalStyle`
  html {
    color: ${Colors.black};
    font-size: 14px;
  }
  @media screen and ${device.md} {
    html {
      font-size: 12px;
    }
  }
  
  #root {
    height: 100vh;
  }

  @font-face {
    font-family:'DMSans';
    src: url(${require('assets/fonts/DMSans-Regular.ttf')});
  }
  @font-face {
    font-family:'NotoSansKR';
    src: url(${require('assets/fonts/NotoSansKR-Regular.otf')});
  }
  @font-face {
    font-family:'SBAggro';
    src: url(${require('assets/fonts/SB-aggroOTF-low.otf')});
  }
  body {
    font-family: 'DMSans', 'NotoSansKR', sans-serif;
    font-size: inherit !important;
  }

  @media print {
    .pdf-container {
      display: none;
    }
  }

  .no-drag {
    -ms-user-select: none;
    -moz-user-select: -moz-none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    user-select:none;
  }

  .slick-prev {
    left: 10px !important;
    z-index: 1;
  }
  .slick-next {
    right: 10px !important;
    z-index: 1;
  }

  .ant-tag {
    background-color: #f0f8f6 ;
    border-radius: 8px !important;
    border-color: #f0f8f6 !important;
    color: ${Colors.white};
  }

  //녹색 체크박스 커스텀
  //체크되었을 때 보더컬러와 배경색
  .green-border-checkbox .ant-checkbox-checked .ant-checkbox-inner {
    border-color:${SecondaryColor};
    background-color:#fff;
  }
  //체크되었을 때 내부 초록색 체크표시
  .green-border-checkbox .ant-checkbox-checked .ant-checkbox-inner::after {
    border-color:${SecondaryColor};
  }
  //체크하기 전 호버, 체크 직후 남아있는 보더
  .green-border-checkbox .ant-checkbox-wrapper:hover .ant-checkbox-inner, 
  .green-border-checkbox .ant-checkbox:hover .ant-checkbox-inner, 
  .green-border-checkbox .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color:${SecondaryColor} !important;
  }

  .ant-select-selector {
    background-color: #f0f8f6 !important;
    border-radius: 8px !important;
    border-color: #f0f8f6 !important;
  }

  .quiz-selector{
    & .ant-select-selector {
    height:45px !important;
    line-height: 45px !important;
    background-color: #F9F9F9 !important;
    border-radius: 8px !important;
    border-color: #AEAEAE !important;
    color:${PrimaryColor};
    align-items: center; //텍스트 세로 정렬
    /* text-align: center; */
  }
  }

  .community-selector{
    & .ant-select-selector {
      height:40px !important;
      line-height: 40px !important;
      background-color: #F9F9F9 !important;
      border-radius: 8px !important;
      border-color: #F9F9F9 !important;
      align-items: center; //텍스트 세로 정렬
      /* color:${PrimaryColor}; */
      /* text-align: center; */
    }

    /* autoComplete input 박스의 border-radius */
    & .ant-select-single .ant-select-selector .ant-select-selection-search-input {
      border-radius: 8px;
      height: 32px;
    }

    /* 화살표 표시 색깔 남색으로 */
    & .ant-select-arrow {
      color:${PrimaryColor};
    }
  }

  .quiz-selector.default{
    & .ant-select-selector {
      background-color: ${Colors.white} !important;
    color:${PrimaryColor} !important
    /* background-color: ${PrimaryColor} !important;
    color:${Colors.white} !important */
  }
  }


  .ant-tooltip-inner {
    border-radius: 8px !important;
  }
  .ant-badge-dot,
  .ant-badge-status-default {
    background-color: ${PrimaryColor} !important;
  }

  .ant-btn {
    background-color: #f0f8f6 !important;
    border-radius: 8px !important;
    padding: 0px 22px !important;
    color: ${PrimaryColor} !important;
    border-color: transparent !important;

  }
  

  .ant-btn.btn-text {
    background-color: transparent !important;
    padding: 0px !important;
    color: ${PrimaryColor} !important;
    &.disabled {
      color: #AEAEAE !important;
    }
  }
  .ant-btn-default {
    background-color: #fff !important;
    border: 1px solid #e5e5e5 !important;
  }
  .ant-btn-sm {
    min-height: 32px;
    line-height: 20px;
  }
  .ant-btn.no-hover {
    cursor: default;
  }
  .ant-btn-primary {
    border-color: transparent !important;
    background-color: ${PrimaryColor} !important;
    color: #fff !important;
  }
  .ant-btn-primary-white-border{
    border-color:#fff !important;
    background-color: ${PrimaryColor} !important;
    color: #fff !important;

  }
  .ant-btn-primary[disabled] {
    background-color: #f5f5f5 !important;
    color: rgba(0, 0, 0, 0.25) !important;
  }
  .ant-btn-dangerous {
    color: ${Colors.danger} !important;
    background: #ffe7e7 !important;
  }
  .btn-disabled {
    background: #e4e4e4 !important;
    color: #747474 !important;
    cursor: default !important;
  }
  .ant-btn-icon-only {
    padding: 0 !important;
  }

  .ant-btn[disabled] {
    opacity: 0.6;
  }
  .ant-btn.pop {
    z-index: 30;
  }
  .ant-btn.secondary {
    color: ${Colors.white} !important;
    background: ${SecondaryColor} !important;
    border-color: ${Colors.white} !important;
  }
  .ant-btn.danger {
    color: ${Colors.white} !important;
    background: ${Colors.danger} !important;
    border-color: ${Colors.white} !important;
  }

  .ant-btn.text {
    color: ${PrimaryColor} !important;
    background: #fff !important;
    border-color: #fff !important;
  }
  .ant-btn.outline {
    color: ${PrimaryColor} !important;
    background: #fff !important;
    border-color: ${PrimaryColor} !important;
  }
  .ant-btn.outline.secondary {
    color: ${SecondaryColor} !important;
    background: #fff !important;
    border-color: ${SecondaryColor} !important;
  }
  .ant-btn.outline.danger {
    color: ${Colors.danger} !important;
    background: #fff !important;
    border-color: ${Colors.danger} !important;
  }
  .ant-btn.small {
    font-size: 0.8rem;
    padding: 0 10px !important;
    min-height: 28px;
    height: auto;
  }
  .ant-btn.large {
    min-height: 44px;
    height: auto;
  }
  .ant-btn.long {
    padding: 0 60px !important
  }

  textarea.ant-input {
    background: ${Colors.grey0} !important;
    border: 0;
    border-radius: 8px;
  }

  .ant-layout {
	  min-height: 100vh !important;
  }

  .ant-layout-header {
    background-color: #fff !important;
    z-index: 10 !important;
  }

  .ant-menu {
	  background-color: #fff !important;
  }
  .ant-menu-light {
	background-color: transparent !important;
  }

  .ant-menu-horizontal {
    border-bottom: 0px !important;
  }

  .ant-menu-horizontal > .ant-menu-item a {
    color: #000 !important;
  }

  .ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {
    height: 24px !important;
    line-height: 24px !important;
  }
  .ant-menu-submenu .submenu-title {
    height: 100%;
    color: #000;
  }
  .share-link-menu-container{
    &.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-open::after{
      border-bottom : 0px ;
    }
    &.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item:hover::after, 
    &.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu:hover::after, 
    &.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-active::after, 
    &.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-active::after, 
    &.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-open::after, 
    &.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-open::after, 
    &.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected::after, 
    &.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-selected::after{
      border-bottom : 0px !important;
    }

    /* &.ant-menu-light .ant-menu-submenu-title:hover,
    &.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu:hover,
    &.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-active,{
      color : #ffffff !important;
    } */
    
  
  }

  .share-link-menu{
    & .ant-menu-vertical > .ant-menu-item {
      height: 37px;
      line-height: 37px;
    }
  }
  
  .ant-spin-nested-loading {
    width: 100%;
  }

  .column-right {
    text-align: right !important;
  }

  .ant-modal-header {
    background: transparent !important;
    border-bottom: none !important;
  }
  .ant-modal-content {
    border-radius: 8px !important;
  }

  .ant-modal-body {
    padding: 18px 24px !important;
    background: transparent;;
  }

  .ant-modal-footer {
    padding: 0px 15px 15px 15px !important;
    background: transparent;;
    border-top: 0px !important;
  }

  .ant-upload.ant-upload-drag {
    height: auto !important;
  }

  .cannot-use-payment{
  .account-number-small{
    display:none;
  }
  .modal-content-small{
    display:none;
  }

  @media screen and ${device.xs} {
    .modal-content{
      font-size:12px;
    }
    .account-number{
      display: none;
    }
    .account-number-small{
      display: inline-block;
      font-size: 14px;
    }
  }

  @media screen and (max-width: 370px) {
    .modal-content{
      display:none;
    }
    .modal-content-small{
      display: inline-block;
      font-size: 12px;
    }
    .account-number-small{
      display: inline-block;
    }
  }
  }

  .normal-modal-container{
    & p{
        margin-bottom:0;
      }
    & .modal-desciption,.modal-desciption-small{
      & p{
        margin-bottom:0;
      }
    }
    .modal-desciption-small{
      display : none;
    }

    @media screen and ${device.xs} {
      .modal-desciption{
        display : none;
      }
      
      .modal-desciption-small{
      display : block;
      }
    }

  }

  .landing-page-modal-container{
  /* &.kakao{
    top: 60px;
    left:40px;
    & .modal-title{
        margin-bottom:0px !important
    }
  } */
  &.framework{
    top: 70px;
    /* right:100px; */
    & .modal-title{
      margin-bottom:10px !important
    }
  }

  .modal-title{
    font-size: 25px;
    font-weight: 900;
    color: ${SecondaryColor};
    text-align: center;
    letter-spacing: 1.4px;
    margin-top: 10px
  }

  .ant-modal-confirm-btns {
    float: none !important;
    .ant-btn-primary  {
      background-color: #f0f9f6 !important;
      color: #003159 !important;
    }
  }

  .ant-modal-header{
    padding: 16px 0 !important;
  }
  .ant-modal-body{
    padding: 18px 0 !important;
  }

  .modal-desciption{
    text-align: center;
    line-height: 0.6;
    color: #14122a;
    letter-spacing: 1.3px;
    & .modal-desciption-title{
      font-size:19px;
    }
  }

  .modal-desciption-title{
    text-align:center;
    margin-bottom:20px;
    font-weight: 900;
    color: ${PrimaryColor};
    letter-spacing: 1.4px;
  }
    
  .modal-desciption_link{
    color: #003159;
    line-height: 1.5 
  }

  .modal-desciption-small{
    display: none;
  }

  .checkbox-text{
    margin:30px 0 10px 0 !important;
    }

  @media screen and ${device.xs} {
  /* width:80%; */

    .modal-desciption-small{
    display: none;
    }
    .modal-title{
      font-size:20px !important;
    }
    .modal-desciption{
      font-size: 11px !important;
      .modal-desciption_link{
        font-size: 13px !important;
      }
    }
    .modal-desciption-smalltext{
      font-size: 8px !important;
      }
    .checkbox-text{
      font-size: 11px;
      margin:20px 0 10px 0 !important;
    }

  }

  @media screen and (max-width: 330px) {
    .modal-desciption{
      display: none;
    }
    .modal-title{
      font-size:16px !important;
    }
    .modal-desciption-small{
      display: block;
      letter-spacing: 0.1px !important;
      font-size: 11px !important;
      text-align: center;
      line-height: 0.6;
      color: #14122a;
      .modal-desciption_link{
        font-size: 13px !important ;
      }
      & .modal-desciption-title{
        font-size:14px;
      }
    }
    .modal-desciption-smalltext{
      font-size: 5px !important;
      }

    .checkbox-text {
      font-size:8px;
    }
  }
  }
  }


  .case-qna-modal-container{
    .modal-title{
      font-size: 25px;
      font-weight: 900;
      color: #003159;
      text-align: center;
      letter-spacing: 1.4px;
      margin-top: 10px;
    }

    .modal-content{
      line-height: 0.6;
      color:#14122a;
      letter-spacing: 1.3px;

        & .modal-checkbox{
          /* display: block !important;
          text-align: center !important; */
          margin-top: 30px !important;
      }

      &.small{
        display: none;
      }
    }

    @media screen and ${device.sm}{
      .modal-title{
        font-size: 20px;
      }
      .modal-content{
        font-size: 12px;
        
        .modal-checkbox{
          font-size: 10px;
        }
      }
    }

    @media screen and ${device.xs}{

      .modal-content{
        font-size: 10px;

        &.small{
          display: block;
          text-align: center;
        }
        &.big{
          display: none;
        }
      }
    }
  }

  

  .ant-descriptions-bordered {
    background-color: #ffffff !important;
  }

  .ant-pagination {
    text-align: center;
    float: none !important;
  }

  .ant-pagination-item:not(.ant-pagination-item-active) {
    border: none;
  }
  .ant-pagination-item a {
    background-color: #F0F8F6;
    height: 100%;
  }

  .ant-pagination-prev .ant-pagination-item-link,
  .ant-pagination-next .ant-pagination-item-link {
    background-color: #F0F8F6 !important;
    border: none !important;
    cursor: pointer;
  }

  .form-item-upload-dragger .ant-form-item-control {
    display: block;
  }
  .form_textarea {
    resize: none;
  }

  .ant-divider-horizontal {
	margin: 16px 0 !important;
  }

  .bs-table {
    .ant-table-row-level-1 > td {
      background-color: #f8f8f8;
    }

    th, td {
      white-space: nowrap;
    }
  }

  .sidemenu-item-group {
    .ant-menu-item-group-title {
      opacity: 0.5;
      font-size: 13px;
    }
  }

  .ant-tag {
    &.mc, &.cc, &.shared, &.ic, &.j {
      background-color: #3486d9;
      color: white;
    }
    &.requested, &.i, &.started_active_offline {
      background-color: #f5cd45;
      color: white;
    }
    &.unshared, &.editing_active_online, &.cp, &.mp, &.ip, &.u {
      background-color: #f8f8f8;
      border-color: #dedfe1;
      color: #b6b6b6;
    }
    &.yellow{
      background-color: #FBBC05;
      color: white;
      border:none ;
      border-radius: 5px !important;
    }
  }
  .ant-tag.small-tag {
    width: 40px;
    height: 20px;
    line-height:20px;
    font-size: 11px;
    border-radius: 4px;
    text-align: center;
  }
  .ant-tag:hover {
    opacity: 1 !important;
  }

  .ant-form-item-control-input {
    & > span {
      width: 100% !important;
    }
  }
  .field-required > div > label::before {
    display: inline-block;
    margin-right: 4px;
    color: #ff4d4f;
    font-size: 14px;
    line-height: 1;
    content: '*';
  }

  .guide-popover {
    .ant-popover-arrow {
      border-color: #2eb88d !important;
    }
    .ant-popover-inner {
      background-color: #2eb88d;
    }

    .ant-popover-title {
      color: white;
      padding-top: 20px !important;
      border-bottom: 0 !important;
    }

    .guide-popover-content {
      width: 250px;
      word-break: keep-all;
      display: inline-block;
    }

    .ant-popover-inner-content {
      color: white;
      & {
        button {
          color: #ffffff !important;
        }
      }
    }
  }

  .table-control-popover {
    .ant-popover-inner-content {
      padding: 15px 16px;
    }

    .table-control-title {
      color: #979797;
      font-weight: bold;
      font-size: 11px;
    }

    .table-control-popover-content {
      width: 240px;
    }
  }

  .table-control-popover-tag.ant-tag {
    cursor: pointer;
    color: #b6b6b6;
    border: 1px solid #dedfe1;
    background-color: #f8f8f8;
    margin-bottom: 8px;
  }

  .table-control-popover-tag.ant-tag-checkable:not(.ant-tag-checkable-checked):hover, .table-control-popover-tag.ant-tag-checkable-checked {
    background-color: #ffffff;
    color: #2eb88d;
    border-color: #2eb88d;
  }

  .form-item-required {
    .ant-form-item-label > label.ant-form-item-no-colon::before {
      display: inline-block;
      margin-right: 4px;
      color: #ff4d4f;
      font-size: 14px;
      line-height: 1;
      content: '*';
    }
  }
  .paragraph-no-margin p {
	margin: 0px;
  }

  .hide-on-desktop {
    display: none !important;
  }
  @media screen and ${device.md} {
    .hide-on-mobile {
      display: none !important;
    }
    .hide-on-desktop {
      display: block !important;
    }
  }

  .date-picker-dropdown {
    height: 32px;
    width: 70px;
    font-size: 14px;
    padding: 0px 5px;
    background: #fff;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
  }
  .date-picker-dropdown:hover {
    cursor: pointer;
  }

  .inline-datepicker-popup {
    left: 0px !important;
    top: 0px !important;
    position: relative !important;

    .ant-picker-week-panel-row-selected td .ant-picker-cell-inner,
    .ant-picker-week-panel-row-selected:hover td .ant-picker-cell-inner {
      color: rgba(0, 0, 0, 0.65);
    }
    .ant-picker-week-panel-row:hover td {
      background: rgba(60, 172, 64, 0.3);
    }
    .ant-picker-week-panel-row-selected td,
    .ant-picker-week-panel-row-selected:hover td {
      background: #fff;
    }
    .ant-picker-week-panel-row-selected {
      border: 1.5px solid ${SecondaryColor};
    }

    .ant-picker-cell-week,
    .ant-picker-header-super-prev-btn,
    .ant-picker-header-super-next-btn {
      display: none;
    }
    .ant-picker-panel-container {
      width: 300px;
      -webkit-box-shadow: none;
      box-shadow: none;
      border: none;
    }
    .ant-picker-panel {
      border: none;
    }
    .ant-picker-header {
      font-size: 10px;
      height: 25px;
      border-bottom: none;
    }
    .ant-picker-header-view {
      font-weight: bold;
    }
    .ant-picker-header > button {
      font-size: 10px;
    }
    .ant-picker-body {
      height: 100px;
      font-size: 10px;
    }
    .ant-picker-cell {
      padding: 0px;
    }
    .ant-picker-cell .ant-picker-cell-inner {
      height: 12px;
      line-height: 12px;
    }
    .ant-picker-cell-disabled::before {
      height: 13px;
    }
    thead {
      display: none;
    }
    .ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner::before {
      border: none;
    }
    .ant-picker-header-view {
      cursor: default;
      pointer-events: none;
    }
  }
  .ant-tag.arrow-box {
    height: 26px;
    width: 26px;
    line-height: 26px;
    border-radius: 8px;
    cursor: pointer;
    background: #f0f8f6;
    border: none;
    padding: 0px 4px;
    .anticon {
      vertical-align: -4px;
      font-size: 16px;
    }
  }
  // react-rator
  .react-rater-star.is-active-half:before,
  .react-rater-star.is-active,
  .react-rater-star.will-be-active {
    color: #ffce50 !important;
  }
  .react-rater-star {
    font-size: 20px;
  }
  .rater-interactive {
    text-align: center;
    .react-rater-star {
      font-size: 60px;
    }
  }
  .small-thumbnail-img {
    width: auto;
    height: 40px;
    border-radius: 50%;
    @media ${device.md}{
      height: 20px;
    }
  }

  .search-input {
    max-width: 300px;
    background: ${LightGrayColor} !important;
    background-color: ${LightGrayColor} !important;
    border: none !important;
    height: 36px;
    border-radius: 8px !important;
    .ant-input {
      background: transparent;
      font-size: 13px;
    }
  }

  .border-box {
    padding: 10px 10px;
    border-radius: 8px;
    border: 1px solid ${LightGrayColor};
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
  }
  .favorite-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    img {
      cursor: pointer;
      width: 15px;
      height: 20px;
    }
    img:hover {
      transform: scale(1.15);
      -webkit-transform: scale(1.15);
    }
  }
  .content-block {
    word-break: break-word;
    white-space: pre-line;
  }
  
  .ellipsis-line-1 {
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-box-pack: center;
    -webkit-line-clamp: 1;
    word-break: break-word;
    white-space: normal;
    overflow: hidden;
  }

  .ellipsis-line {
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-box-pack: center;
    -webkit-line-clamp: 2;
    word-break: break-word;
    white-space: normal;
    overflow: hidden;
  }
`;

export const TableWrapper = styled.div`
  .ant-table-small .ant-table-thead > tr > th {
    border-color: ${PrimaryColor};
  }
  .ant-table-thead > tr > th {
    text-align: center;
    font-weight: bold;
    color: ${PrimaryColor};
  }
  .ant-table-cell {
    padding: 8px 0px !important;
    a {
      display: block;
    }
  }
  .ant-pagination-next,
  .ant-pagination-prev,
  .ant-pagination-item {
    margin: 0px 5px !important;
  }
  .ant-pagination-item a {
    height: 100%;
  }
  .ant-pagination-item-active:focus a,
  .ant-pagination-item-active:hover a,
  .ant-pagination-item-active a {
    background-color: ${PrimaryColor};
    color: #fff;
  }
`;

export const TableHeaderWrapper = styled.div`
  width: 100%;
  display: inline-block;
  margin-bottom: 20px;

  .add-button {
    display: inline-block;
    float: right;

    @media screen and ${device.lg} {
      display: block;
    }
  }
`;

export const BoxWidth = '420px';
export const FormWrapper = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  overflow: hidden;
  padding: 40px 0px;

  
  .label-top {
    font-size: 12px;
    font-weight: bold;
    color: #000000d9;
    padding: 2px 11px;
    margin-bottom: 5px;
  }

  .btn-center {
    padding: 0px !important;
  }
  // label이 form field와 같은 box에 있는 스타일
  .form-inline .form-button {
    margin-top: 30px;
    margin-bottom: 10px;
    & button {
      width: 100%;
    }
    button:disabled {
      background-color: #dedfe1 !important;
    }
  }

  .form-inline .form-item .ant-form-item-control-input {
    background: ${LightGrayColor};
    border-radius: 0px 0px 8px 8px !important;
  }
  .form-inline .form-item.form-item-no-label .ant-form-item-control-input {
    border-radius: 8px !important;
  }
  .form-inline .form-item .ant-form-item-label {
    background: ${LightGrayColor};
    border-radius: 8px 8px 0px 0px !important;
    padding: 6.5px 11px 0px 11px !important;
    label {
      font-size: 12px !important;
      font-weight: bold;
    }
  }
  .form-inline .form-item.no-background .ant-form-item-label {
    background: #fff !important;
  }
  .form-inline .ant-picker {
    background: transparent;
    border: transparent;
    width: 95%;
    margin-left: 2px;
  }
  .form-inline .ant-picker-input > input {
    font-size: 14px !important;
  }
  .form-inline .list-delete-button {
    cursor: pointer;
    text-align: center;
    height: calc(100% - 12px);
    margin-left: 6px;
    background: #ffe7e7;
    color: ${Colors.danger};
    border-radius: 8px;
    font-size: 16px;
    span {
      top: calc(50% - 6px);
      transform: translate(-50%, -50%);
      position: absolute;
    }
  }
  .form-inline .list-plus-button {
    text-align: center;
  }
  // label이 form field와 분리되어있는 스타일
  .form-normal .form-item .ant-form-item-control-input {
    background: ${LightGrayColor};
    border-radius: 8px !important;
  }
  .form-normal .ant-form-item-label {
    label {
      font-size: 14px !important;
      font-weight: bold;
    }
  }
  .form-normal .form-item-fit-content .ant-form-item-control {
    height: 32px;
  }
  .form-normal .no-margin {
    margin-bottom: 0px;
  }
  .form-normal .ant-btn {
    float: right;
    padding: 0px 30px !important;
  }

  .form-normal .ant-btn.list-minus-button{
    padding: 0px 10px !important;
    background-color: #FFE7E7 !important;
  }

  .ant-btn.list-minus-button {
    padding: 0px 10px !important;
    background-color: #FFE7E7 !important;
    margin: 5px;
  }
  .ant-btn.list-plus-button{
    padding: 0px 10px !important;
    margin: 5px;

  }


  /* .form-normal .list-minus-button{
    cursor: pointer;
    padding: 10px ;
    background-color: #FFE7E7 ;
    transition: margin-left 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  } */

  // 공통 스타일
  .ant-input,
  .ant-input-password,
  .ant-input-affix-wrapper,
  .ant-input-number {
    background: transparent !important;
    border: none;
    font-size: 14px;
  }
  .ant-input-suffix {
    font-size: 14px;
    color: ${PrimaryColor};
  }
  .ant-input-suffix .hoverable:hover {
    cursor: pointer;
  }
  .force-black .ant-input[disabled] {
    color: #000 !important;
    cursor: default;
  }
  .ant-form-item-label > label.ant-form-item-required::before {
    content: none;
  }
  .with-required
    .required-none
    .ant-form-item-label
    > label.ant-form-item-required::after {
    content: none;
  }
  .with-required .required .ant-form-item-label > label::after,
  .with-required .ant-form-item-label > label.ant-form-item-required::after {
    content: "*";
    display: inline-block;
    margin-left: 4px;
    color: #ff4d4f;
    font-size: 14px;
    font-family: SimSun, sans-serif;
    line-height: 1;
  }
  .ant-form-item-has-feedback .ant-input-affix-wrapper .ant-input-suffix {
    padding-right: 0px;
  }
  .ant-input:placeholder-shown {
    font-size: 14px;
  }
  .ant-input-number {
    width: 100%;
  }
  .ant-input-number input {
    padding: 0px 11px !important;
  }
  .ant-input-number-handler-wrap {
    display: none;
  }
  .form-bottom {
    a {
      color: ${PrimaryColor};
    }
    .ant-form-item {
      display: inline-block;
    }
  }
  .form-bottom.ant-form-item {
    margin-bottom: 0px;
  }
  h2.ant-typography {
    margin: 5px auto;
  }
  .ant-typography {
    color: #000;
  }
  .ant-btn-sm {
    height: 24px !important;
    line-height: 24px;
    font-size: 12px;
    padding: 0px 15px !important;
  }
  // antd Radio
  .ant-radio-group {
    width: 100%;
  }
  label.ant-radio-button-wrapper {
    border-color: transparent;
    background: transparent;
    text-align: center;
  }
  .col-12 .ant-radio-button-wrapper {
    width: 50%;
  }
  .col-8 .ant-radio-button-wrapper {
    width: 33.3%;
  }
  .col-6 .ant-radio-button-wrapper {
    width: 25%;
    @media screen and ${device.lg} {
      width: 100%;
    }
    /* @media screen and ${device.md} {
      width: 100%;
    } */
  }
  .col-20p .ant-radio-button-wrapper {
    width: 16.65%;
    font-size: 11px;
    /* padding:0 39px; */
    @media screen and ${device.lg} {
      width: 100%;
    }
    /* @media screen and ${device.md} {
      width: 100%;
    } */
  }
  label.ant-radio-button-wrapper:not(.ant-radio-button-wrapper-checked) {
    color: #a9a9a9;
  }
  .ant-radio-button-wrapper:last-child {
    border-radius: 0 8px 8px 0;
  }
  .ant-radio-button-wrapper:first-child {
    border-radius: 8px 0 0 8px;
  }
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    border-color: ${PrimaryColor};
    background: #fff;
  }

  //green
  //해당 radio button 체크 되었을 때(disabled 버튼이 아닐 때)
  .green-border.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    border-color: ${SecondaryColor};
    color:${SecondaryColor};
  }
  .green-border.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before{
    background-color: ${SecondaryColor};
    transition:unset;
  }
  //초록색 버튼이 첫번째일 경우
  .green-border.ant-radio-button-wrapper-checked:not([class*=' ant-radio-button-wrapper-disabled']).ant-radio-button-wrapper:first-child {
    border-right-color: ${SecondaryColor};
  }
  
  //navy
  .navy-border.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    border-color: ${PrimaryColor};
    color:${PrimaryColor};
  }
  .navy-border.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before{
    background-color:${PrimaryColor};
    transition:unset;
  }
  
  //red
  .red-border.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    border-color: ${Colors.danger};
    color:${Colors.danger};
  }
  .red-border.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
    background-color: ${Colors.danger};
    transition:unset;
  }
  //빨간색 버튼이 첫번째일경우
  .red-border.ant-radio-button-wrapper-checked:not([class*=' ant-radio-button-wrapper-disabled']).ant-radio-button-wrapper:first-child{
    border-right-color: ${Colors.danger};
  }
  
  // 스위치
  .ant-switch {
    border-radius: 8px;
    margin-right: 5px;
    width: 50px;
  }
  .ant-switch-checked .ant-switch-handle {
    left: calc(100% - 9px - 2px);
  }
  .ant-switch-handle {
    width: 9px;
  }
  .ant-switch-inner {
    margin: 0 7px 0 16px;
  }
  .ant-switch-checked .ant-switch-inner {
    margin: 0 16px 0 7px;
  }
  // Upload
  .ant-upload.ant-upload-select {
    float: right;
    padding: 0px 11px;
    .input-suffix {
      color: ${PrimaryColor};
      font-size: 14px;
      cursor: pointer;
    }
  }
  .ant-upload-list {
    width: calc(100% - 60px);
  }
  .ant-upload-list-item {
    margin-top: 0px;
  }
  .ant-upload-list-item-info {
    padding-left: 11px;
  }
  .ant-upload-plus {
    font-size: 18px;
    color: ${PrimaryColor};
  }
  .ant-upload-text {
    font-size: 14px !important;
  }
  .ant-upload.ant-upload-drag {
    height: auto !important;
    border: 1px dashed #fff;
  }
  .ant-upload-drag + .ant-upload-list {
    width: 100%;
  }
  .ant-upload-list-item-card-actions-btn {
    background: transparent !important;
  }
  // 버튼모양 checkbox
  .checkbox-btn {
    .ant-checkbox-wrapper {
      background: #f0f8f6;
      border-radius: 8px;
      padding: 2px 5px;
      margin-right: 8px;
      margin-bottom: 8px;
      color: ${PrimaryColor};
    }
    .ant-checkbox-wrapper-checked {
      background: ${PrimaryColor};
      color: #fff;
    }
    .ant-checkbox {
      width: 0;
    }
    .ant-checkbox.ant-checkbox-checked + span {
      margin-left: 10px;
    }
    .ant-checkbox + span {
      font-size: 14px;
    }
    .ant-checkbox-inner {
      background: transparent;
      border: none;
    }
    .ant-checkbox-wrapper + .ant-checkbox-wrapper {
      margin-left: 0px;
    }
  }
`;

export default GlobalStyles;
